export default __webpack_public_path__ + "static/media/ring.d4e6561a.wav";